/**
 * This is a simplified version of the [vue-js-modal](https://github.com/euvl/vue-js-modal). It is compatible with Bulma and does not style the modal content at all. Content should be styled when it is passed to the modal's content slot.
 * @type {Object}
 */

import Modal from './Modal.vue';

const Plugin = {
  install(Vue) {
    /**
     * Makes sure that plugin can be installed only once
     */
    if (this.installed) {
      return;
    }
    this.installed = true;
    this.event = new Vue();

    Vue.prototype.$modal = new Vue({
      data: {
        visible: [],
      },
      methods: {
        /**
         * Show the modal with the given name and pass params to its slot's slot-scope
         * @param  {String} name        Name attribute asigned as an attribute on the modal component
         * @param  {Object} [params={}] Parameters to pass to the modal's slot slot-scope so that components within the slot can recieve props
         */
        show(name, params = {}) {
          Plugin.event.$emit('toggle', name, true, params);
          if (this.visible.indexOf(name) < 0) {
            this.visible.push(name);
          }
        },
        /**
         * Hide the modal with the given name, if it is visible
         * @param  {String} name        Name attribute asigned as an attribute on the modal component
         * @param  {Object} [params={}]  Parameters to pass to the modal's slot slot-scope so that components within the slot can recieve props
         */
        hide(name, params = {}) {
          Plugin.event.$emit('toggle', name, false, params);
          let loc = this.visible.indexOf(name);
          if (loc > -1) {
            this.visible.splice(loc, 1);
          } else if (name === '*') {
            this.visible = [];
          }
        },
        /**
         * Toggle the visible state of the modal with the given name
         * @param  {String} name        Name attribute asigned as an attribute on the modal component
         * @param  {Object} [params={}]  Parameters to pass to the modal's slot slot-scope so that components within the slot can recieve props
         */
        toggle(name, params = {}) {
          Plugin.event.$emit('toggle', name, undefined, params);
          let loc = this.visible.indexOf(name);
          if (loc > -1) {
            this.visible.splice(loc, 1);
          } else {
            this.visible.push(name);
          }
        },
      },
    });

    // Register the plugin
    const componentName = 'modal';
    Vue.component(componentName, Modal);
  },
};

export default Plugin;
